let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gWGat")).then(() => parcelRequire('1F2pX'));